import React from 'react';

const FloatingElements = () => {
  // Generate butterflies at different positions
  const butterflies = [
    { id: 1, left: '10%', top: '20%', delay: 0, duration: 15 },
    { id: 2, left: '30%', top: '40%', delay: 3, duration: 18 },
    { id: 3, left: '60%', top: '15%', delay: 6, duration: 14 },
    { id: 4, left: '80%', top: '35%', delay: 9, duration: 16 },
    { id: 5, left: '20%', top: '60%', delay: 12, duration: 17 },
    { id: 6, left: '50%', top: '50%', delay: 4, duration: 19 },
  ];

  // Sparkles for magical effect
  const sparkles = Array.from({ length: 15 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    delay: Math.random() * 5,
    duration: 4 + Math.random() * 3,
  }));

  return (
    <>
      {/* Butterflies */}
      {butterflies.map((b) => (
        <div
          key={b.id}
          className="butterfly"
          style={{
            left: b.left,
            top: b.top,
            animationDelay: `${b.delay}s`,
            animationDuration: `${b.duration}s`,
          }}
        />
      ))}

      {/* Water ripple effect at bottom */}
      <div className="water-container">
        <div className="water-ripple" style={{ animationDelay: '0s' }} />
        <div className="water-ripple" style={{ animationDelay: '2s' }} />
        <div className="water-ripple" style={{ animationDelay: '4s' }} />
      </div>

      {/* Sparkles */}
      {sparkles.map((s) => (
        <div
          key={s.id}
          className="sparkle"
          style={{
            left: s.left,
            top: s.top,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.duration}s`,
          }}
        />
      ))}
    </>
  );
};

export default FloatingElements;
